var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSfm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a72cfcbb-6987-46c8-b6f4-9423a6a22c4e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-4c62ed3a-e0d9-4ccc-81b6-d0232458713d{fill:#fff;}.uuid-6366c17a-3fcf-4c12-a5f4-d118c6a27a75{fill:url(#uuid-25cbb457-a6a8-4543-8ca3-98900d4b0dbc);fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-25cbb457-a6a8-4543-8ca3-98900d4b0dbc",
    x1: 106.31,
    y1: 385.04,
    x2: 405.69,
    y2: 385.04,
    gradientTransform: "translate(0 641.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#00752f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#72bf54"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-4c62ed3a-e0d9-4ccc-81b6-d0232458713d",
    x: -0.5,
    y: -0.5,
    width: 513,
    height: 513
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6366c17a-3fcf-4c12-a5f4-d118c6a27a75",
    d: "m394.01,196.47c-7.68-18.56-18.63-35.16-32.93-49.42-14.46-14.43-31.44-25.54-50.3-33.61-18.43-7.88-37.96-11.65-57.91-12.3,84.03,26.5,132.19,116.31,99.69,199.95-23.4,60.01-92.39,89.94-151.92,63.56-1.84-.81-3.68-1.71-5.46-2.58-10.1-8.81-17.66-20.11-21.6-33.93-9.07-31.77,1.61-71.09,36.12-95.78-61.24,20.73-69.05,106.34-26.83,142.36-10.07-7.1-18.85-14.91-26.41-23.18-24.57-30.57-33.48-68.47-27.25-103.98,103.72-32.64,45.55-91.78,100.11-147.01-112.34-1.55-124.58,72.51-118.28,118.18,2.78-25.08,39.64-78.25,76.93-96.62-62.5,58.37-109.21,141.2-62.08,218.9-7.55-8.01-14.14-16.59-19.6-25.31,55.14,128.77,243.54,127.48,289.12-2.84,6.94-18.08,10.27-37,10.27-56.4,0-20.73-3.78-40.87-11.69-60.01Zm-221.87,177.84c.45-.13.9-.26,1.36-.36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSfm);
export default __webpack_public_path__ + "static/media/icon_sfm.60f3cda0bf93c71ae52df38ebebd6c27.svg";
export { ForwardRef as ReactComponent };